import {put, takeLatest} from "redux-saga/effects";
import {appNotify, fetchRegions, setRegions, setIsLoading} from "../store/actions";
import {getWithToken} from "../api/network";

export function* getDashboardInventoryRegionsSaga() {
  yield takeLatest(fetchRegions, function* () {
    try {
      const type = "regions";
      yield put(setIsLoading({inventoryType: type, isLoading: true}));

      let url = `/api/dashboard/getDashboardInventoryRegions`;
      const res = yield getWithToken(url);
      const regionsObj = yield res.json();
      const regions = yield regionsObj.map(x => x.region);

      console.log(`Regions: `, regions);

      yield put(setRegions({regions, inventoryType: type}));
      yield put(setIsLoading({inventoryType: type, isLoading: false}));
    } catch (error) {
      console.error(error);
      yield put(appNotify(`Failed to fetch regions: ${error.message}`, 'error'));
    }
  });
}
